import { useSelector } from 'react-redux';
import { buildDomain, buildUrl } from '../../ecg/hooks/use-holter-strip-url';
import { ecgIdSelector } from '../../ecg/selectors/ecg.selectors';
import { SECOND } from '../../utils/time';
import { getServerCode } from '../client/helpers';
import { projectedBaseClusterSelector } from '../selectors/cluster.selectors';

export const useHolterClusterUrl = (onset: number) => {
  const ecgId = useSelector(ecgIdSelector);
  const cluster = useSelector(projectedBaseClusterSelector);

  if (ecgId == null || cluster == null) {
    return '#';
  }
  const code = getServerCode(cluster.classification);
  // Set the timestamp 5 seconds less so the beat
  // is aligned in the middle of the lead view plot
  const timestamp = onset / SECOND - 5 > 0 ? onset / SECOND - 5 : 0;
  if (process.env.NODE_ENV === 'development') {
    return buildUrl(ecgId, timestamp, 'staging', [], code);
  }

  const domain = buildDomain(window.location);

  return buildUrl(ecgId, timestamp, domain, [], code);
};
